import React, { useState } from "react";
import ancientayurveda from '../Assests/images/ancient_ayurveda.png'
import modernayurveda from '../Assests/images/modern_science.png'
import evidencebacked from '../Assests/images/evidence_backed.png'

const outcomes = [
  {
    img: "./../assets/corporateAssert/Outcome 1.png",
    title: "Peak Performance",
    subtitle: "Less Stress, More Focus",
  },
  {
    img: "./../assets/corporateAssert/Outcome 2.png",
    title: "Fewer Sick Days",
    subtitle: "Stronger Immunity, High Energy",
  },
  {
    img: "./../assets/corporateAssert/Outcome 3.png",
    title: "Higher Productivity",
    subtitle: "Better Digestion & Sleep",
  },
  {
    img: "./../assets/corporateAssert/Outcome 4.png",
    title: "Smarter Savings",
    subtitle: "Lower Healthcare Costs",
  },
  {
    img: "./../assets/corporateAssert/Outcome 5.png",
    title: "Higher Job satisfaction",
    subtitle: "Happier Workplace",
  },
];


const Choose = () => {
  const [counts, setCounts] = useState([0, 0, 0]);

  const increment = (index) => {
    const newCounts = [...counts];
    newCounts[index] += 1;
    setCounts(newCounts);
  };
  return (

    <div className="choose-background ">

      <div >
        <h2 className="choose-title">Why Choose Ayur.AI</h2>
      </div>

      <div className="choose-main">  
        <div className="new-container">
          
          <div className="box">
            <img src={ancientayurveda} className="choose-img"></img>
            <p className="choose-outcome">Ancient Ayurveda</p>
            <p className="choose-content">Ayurveda, a 5,000-year-old healing science, restores balance through natural remedies, nutrition, and mindful living. By addressing root causes, it promotes lasting health and vitality, blending ancient wisdom with modern wellness.</p>
          </div>
          
          <div className="box">
            <img src={modernayurveda} className="choose-img"></img>
            <p className="choose-outcome">Modern Science</p>
            <p className="choose-content">Modern science, driven by research and innovation, unravels the complexities of health and wellness through advanced technology and evidence-based solutions. Continuously evolving, it enhances diagnostics, treatments, and preventive care, improving lives with precision and efficiency.</p>
          </div>

          <div className="box">
            <img src={evidencebacked} className="choose-img"></img>
            <p className="choose-outcome">Evidence Backed</p>
            <p className="choose-content">Evidence-backed wellness relies on scientific research and proven data to ensure safe, effective, and reliable health solutions. Rooted in rigorous testing and validation, it empowers informed choices for lasting well-being</p>
          </div>

        </div>
      </div>
    </div>

  );
};

export default Choose;
